import React from 'react';
import TeX from '@matejmazur/react-katex';
interface IQuizOption {
  // eslint-disable-next-line @typescript-eslint/ban-types
  onAnswer?: (option: unknown) => void;
  option: unknown;
  index: number;
  labelOptionKey: string;
  // focus: any;
  // questionId: any;
  math: boolean;
}
export default function QuizOption({
  option,
  onAnswer,
  index,
  labelOptionKey,
  math,
}: // focus,
// math,
IQuizOption) {
  const state = (option as { [x: string]: unknown })?.['state'] as
    | 'default'
    | 'wrong'
    | 'correct'
    | 'selected';

  console.log(state);

  const color =
    state === 'selected'
      ? 'blue'
      : state === 'correct'
      ? 'green'
      : state === 'wrong'
      ? 'red'
      : '';

  return (
    <div
      className={`flex ${
        onAnswer ? 'hover:shadow-sm cursor-pointer' : ''
      } ml-2 mr-2 flex rounded-md mb-3 bg-gray-50 bg-${color}-100`}
      onClick={() => onAnswer?.(option)}
    >
      <div className="flex items-center flex-no-wrap my-2">
        <div
          className={`text-xs flex-shrink-0 rounded-full border border-gray-300 h-8 w-8 flex items-center justify-center mx-2 ${
            color ? `bg-${color}-600 text-white` : ''
          }`}
        >
          {index + 1}
        </div>
        <div>
          {math ? (
            <TeX>
              {' '}
              {(option as { [x: string]: unknown })[labelOptionKey] as string}
            </TeX>
          ) : (
            <p
              className={`font-medium text-md ${
                color ? `text-${color}-800` : ''
              }`}
            >
              {(option as { [x: string]: unknown })[labelOptionKey] as string}{' '}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
